import { useState } from 'react';
import { t } from '../i18n/languages';

function useLanguage() {
  const [currentLanguage, setCurrentLanguage] = useState('hr');

  return {
    currentLanguage,
    setCurrentLanguage,
    t: (key, params = {}) => t(key, params, currentLanguage)
  };
}

export default useLanguage;
